import React from 'react';
import { SectionSplitter } from '../SideMenuPopover';
import ActionsUserProfile from './ActionsUserProfile.component';
import FooterUserProfile from './FooterUserProfile.component';
import PersonalDetails from './PersonalDetails.component';

const PopoverUserProfile: React.FC<React.PropsWithChildren> = () => {
  return (
    <>
      <PersonalDetails />
      <SectionSplitter />
      <ActionsUserProfile />
      <SectionSplitter />
      <FooterUserProfile />
    </>
  );
};

export default PopoverUserProfile;
